export const GLOBAL_ACCOUNT_ID_PARAM = 'globalAccountId';
export const INVITATION_ID_PARAM = 'invitationId';
export const ELLIPSIS = '...';

export const DATE_FORMAT = 'dd MMM yyyy';
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

export const FAILED_TO_FETCH_ERR_MESSAGES = [
  'Failed to fetch',
  'Load failed',
  'NetworkError when attempting to fetch resource.',
];

export const EXTERNAL_PASSPORT_APP_DOMAIN_NAME = 'carrierlogistics';
